module.exports = __webpack_public_path__ + "static/media/599.767 (5).ccf300f9.pdf";